var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"p-5",attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group mb-3"},[_c('label',{staticClass:"form-check-label text-light",attrs:{"for":"rememberMe"}},[_vm._v(" Please find the confirmation email sent to your email address. ")])])
}]

export { render, staticRenderFns }